import StudentPage from 'modules/students/screens/StudentPage' ;
import SearchPage from 'modules/search/screens/SearchPage';

const routes = [
  {
    path: "/students/:id",
    name: "Ficha del Alumno",
    icon: "nc-icon nc-circle-10",
    component: StudentPage,
    layout: "/admin",
  },
  {
    path: "/search",
    name: "Buscar",
    icon: "nc-icon nc-circle-10",
    component: SearchPage,
    layout: "/admin",
  }
];

export default routes;
